export default __webpack_public_path__ + "06809497c44487810d740532db4db9a1.png";